import { GATSBYIMGLOADING } from '@et/types/Enums'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { ICourseDiffItem } from './whatMakesCourseDiffList'
import { twMerge } from 'tailwind-merge'

interface Props {
  item: ICourseDiffItem
  titleClasses?: string
  descriptionClasses?: string
}

function CourseDiffItem(props: Props) {
  const { item: { title, description, image }, titleClasses, descriptionClasses } = props

  return (
    <div className='container relative mb-28'>

      <div className='relative h-full p-6 pt-12 pb-8 text-center bg-white rounded-xl z-2'>
        <div className='max-w-[200px] w-full absolute left-[57%] -translate-x-1/2 top-[-60px]'>
          <GatsbyImage alt={title} image={image.gatsbyImageData} loading={GATSBYIMGLOADING.LAZY} />
        </div>
        <h3 className={twMerge('text-2xl font-bold text-grey-800 pt-[220px]', titleClasses)}>{title}</h3>
        <p className={twMerge('text-lg text-grey-600', descriptionClasses)}>{description}</p>
      </div>
      {/* 0px 21px 55px rgba(0, 0, 0, 0.18) */}
      <div className='absolute bgShadow z-1 bottom-0 w-[70%] h-[80%] left-1/2 -translate-x-1/2 shadow-[0_21px_55px_rgb(0,0,0,0.18)]'></div>

    </div>
  )
}

export default CourseDiffItem
